"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROW_SIZES_CSS = exports.ROW_SIZES = void 0;
// eslint-disable-next-line import/prefer-default-export
const ROW_SIZES = ["extra-small", "small", "medium-small", "medium", "medium-large", "large", "extra-large"];
exports.ROW_SIZES = ROW_SIZES;
const ROW_SIZES_CSS = {
  none: 0,
  "extra-small": 2,
  small: 5,
  "medium-small": 10,
  medium: 15,
  "medium-large": 30,
  large: 60,
  "extra-large": 90
};
exports.ROW_SIZES_CSS = ROW_SIZES_CSS;